
import { mapState, mapMutations } from "vuex";
import { Contact } from "@/graphql/contact";
import { ContactForm } from "@/graphql/form";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import "~/plugins/vee-validate.js";
import "~/plugins/v-mask.js";

export default {
  components: {
    ValidationProvider: ValidationProvider,
    ValidationObserver: ValidationObserver,
  },
  nuxtI18n: {
    paths: {
      "en-ca": "/contact",
      "fr-ca": "/contact",
    },
  },
  async asyncData({ app, i18n }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();
    const contactResponse = await client.query({
      query: Contact,
      variables: { locale: locale },
    });
    const contact = contactResponse.data.contact.data.attributes;
    return { contact };
  },
  data() {
    return {
      contact: {},
      show: false,
      anchorSelected: "",
      form: {
        subject: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        city: "",
        region: "",
        message: "",
      },
    };
  },
  head() {
    return {
      title: this.contact.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.contact.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.contact.SEO.MetaDescription,
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
    async onSubmit() {
      try {
        await this.$apollo.mutate({
          mutation: ContactForm,
          variables: {
            data: this.formattedPayload().data,
          },
        });
        this.sendEmail();
        this.$router.push(this.localePath("/contact/confirmation"));
      } catch (error) {
        console.log(error);
      }
    },
    formattedPayload() {
      return { data: { ...this.form } };
    },
    async sendEmail() {
      try {
        await this.$axios
          .post("/formulaire-contact/send", {
            email: this.form,
            lang: this.$i18n.locale,
          })
          .then((response) => {
            console.log(response);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    pageScroll: function () {
      //Ajouter - le height du Header fix apres le bottom
      let haveShow = false;
      if (
        this.$refs.animated?.getBoundingClientRect().bottom -
          window.innerHeight +
          100 <=
        0
      ) {
        this.show = true;
        haveShow = true;
      }
    },
  },
};
